import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ObjectService {

  httpHeaderOptions: any;
  constructor(
    private http: HttpClient
  ) {
    this.httpHeaderOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      })
    }
  }

  getObjectList(id: number, params): Observable<any> {
    return this.http.get(environment.apiEndpoint + 'other_list/' + id + '/?' + params, this.httpHeaderOptions)
  }

  deleteObject(id: number): Observable<any> {
    return this.http.put(environment.apiEndpoint + 'other_delete/' + id + '/', {}, this.httpHeaderOptions)
  }

  addObject(data: any): Observable<any> {
    return this.http.post(environment.apiEndpoint + 'other_add/', data, this.httpHeaderOptions)
  }

  getmoduleObjectList(app): Observable<any> {
    return this.http.get(environment.apiEndpoint + 'other_list_new_by_module_name/' + app + '/', this.httpHeaderOptions)
  }

  addModuleObject(data: any): Observable<any> {
    return this.http.post(environment.apiEndpoint + 'other_add_new/', data, this.httpHeaderOptions)
  }

  editObject(id: number, data: any): Observable<any> {
    return this.http.put(environment.apiEndpoint + 'other_edit/' + id + '/', data, this.httpHeaderOptions)
  }

  getSubObjectList(module_id: number, parent_id: number, params): Observable<any> {
    return this.http.get(environment.apiEndpoint + 'other_list_by_parent/' + module_id + '/' + parent_id + '/?' + params, this.httpHeaderOptions)
  }

  getObjectDetails(id: number): Observable<any> {
    return this.http.get(environment.apiEndpoint + 'other_edit/' + id + '/', this.httpHeaderOptions)
  }

  updateObject(id: number, data: any): Observable<any> {
    return this.http.put(environment.apiEndpoint + 'other_edit_new/' + id + '/', data, this.httpHeaderOptions)
  }
}
